<template>
  <div style='height: 100vh'>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'dealsheet',
    computed: {
      aaId: function () {
        let vm = this;
        if (!vm.$route.query.aaId) return ''
        else return vm.$route.query.aaId
      },
      entityId: function () {
        let vm = this;
        if (!vm.$route.query.entityId) return ''
        else return vm.$route.query.entityId
      }
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/Dealsheet/Dealsheet.vue